module.exports = __webpack_public_path__ + "images/FUSA_icons/037-credit-card-1.34c2a5dffdce2203f569f0f8cad870a3.svg";